import { Button, ControlledInput } from "@/components";
import { PublicRoutes } from "@/constants/routes";
import { useResetPassword } from "@/domain/auth";
import { zodResolver } from "@hookform/resolvers/zod";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useSearchParams } from "react-router";
import { z } from "zod";

const resetPasswordSchema = z
  .object({
    password: z.string().min(1, "Senha obrigatória"),
    confirmPassword: z.string().min(1, "Confirme a senha"),
  })
  .refine(data => data.password === data.confirmPassword, {
    message: "As senhas não coincidem",
    path: ["confirmPassword"],
  });

type ResetPasswordSchema = z.infer<typeof resetPasswordSchema>;

export const ForgotPasswordReset = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();

  const phone = params.get("phone") ?? "";
  const code = params.get("code") ?? "";

  const { resetPassword, isPendingResetPassword } = useResetPassword({
    phone,
    code,
  });

  const { control, handleSubmit, formState } = useForm<ResetPasswordSchema>({
    defaultValues: { password: "", confirmPassword: "" },
    resolver: zodResolver(resetPasswordSchema),
  });

  // Sem telefone/código a etapa anterior foi pulada — volta ao início.
  useEffect(() => {
    if (!phone || !code) navigate(PublicRoutes.AUTH_FORGOT_PASSWORD_PHONE);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onResetPassword = (data: ResetPasswordSchema) => {
    resetPassword(data.password);
  };

  return (
    <div className="flex flex-col gap-8">
      <div className="flex flex-col gap-1">
        <h1 className="text-2xl font-semibold text-black">Nova senha</h1>
        <p className="text-base text-gray-500">
          Defina uma nova senha para acessar sua conta.
        </p>
      </div>

      <form
        className="flex flex-col gap-5"
        onSubmit={handleSubmit(onResetPassword)}
      >
        <ControlledInput
          control={control}
          name="password"
          type="password"
          label="Nova senha"
          placeholder="Digite a nova senha"
        />
        <ControlledInput
          control={control}
          name="confirmPassword"
          type="password"
          label="Confirmar senha"
          placeholder="Confirme a nova senha"
          errorMessage={formState.errors.confirmPassword?.message}
        />
        <Button
          type="submit"
          isLoading={isPendingResetPassword}
          disabled={!formState.isValid || isPendingResetPassword}
        >
          Redefinir senha
        </Button>
      </form>
    </div>
  );
};
